// Utility methods for accessing device-specific information.

export const POS_DEVICE_TYPES = {
  E700: 'E700',
  OTHER: 'OTHER',
}

// returns : The unique device ID of this piece of hardware.
export const getDeviceId = () => localStorage.getItem('device_id')

/**
 * Fetch device serial number falling back to deviceId
 */
export const getDeviceSerial = (fallbackToDeviceId = true) => {
  const serialNumber = localStorage.getItem('serial_number')
  if (!serialNumber && fallbackToDeviceId) {
    return getDeviceId()
  }

  return serialNumber
}

// returns : The unique, expiring session ID for this device, with a fallback to token expiry.
export const getSessionId = () => localStorage.getItem('sessionId') || localStorage.getItem('expiresAt')

// returns : The unique, expiring access token for this device.
export const getAccessToken = () => localStorage.getItem('accessToken')
